import React, { useState, useEffect, useRef, useContext } from 'react';
import '../css/header.css';
import { fetchWithDefaults } from '../config/fetchDefault';
import {setOpenLeaderBoard, setOpenMessages, setOpenCalls,setOpenVoicemails} from '../features/topBarSlice';
import logo from '../assets/icons/QuilitySwitchboardFunnel.svg';
import b2blogo from '../assets/icons/QuilitySwitchboardFunnelB2B.png';
import { useSelector, useDispatch } from 'react-redux';
import AgentInfo from './header/agentInfo';
import Icon from '../assets/icons/icon';
import { useDebouncedCallback } from 'use-debounce';
import '../css/quilityIcons.css'
import { AgentContext } from '../context/AgentContext';
import BrandedIconButton from '../utilities/inputComponents/BrandedIconButton';
import XClose from '../svgIcon/XClose';
import { brandedButtonTypes } from '../utilities/inputComponents/BrandedButton';

function HeaderBar({signOut, openLead, fetchPage}) {
	const dispatch= useDispatch();
	const agentId=useSelector((state) => state.agent.userData).agentId;
	const agentInfo=useSelector((state) => state.agent.userData);
	const dynamicLogo=useSelector((state) => state.agent).logo;
	const unheardVoicemails=useSelector((state) => state.voicemails.unheard);
	const [searchTerm, setSearchTerm] = useState('');
	const [bugReport, setBugReport] = useState(false);
	const [isBentoOpen, setIsBentoOpen] = useState(false);
	const [search, setSearch] = useState(false);
	const [typingTimeout, setTypingTimeout] = useState(null);
	const [isRequestPending, setIsRequestPending] = useState(false);
	const [results, setResults] = useState(false);
	const [bento, setBento] = useState(false);
    const agentUnreadMessages = useSelector(state => state.conversations.unreadMessages)
    const agentMissedCalls = useSelector(state => state.missedCall.missedCall)
    const { organization } = useSelector(state => state.agent.userData)

    const searchInputRef = useRef(null)

	useEffect(() => {
		return () => {
		// Clear the typing timeout when component unmounts
		if (typingTimeout) {
			clearTimeout(typingTimeout);
		}
		};
	}, [typingTimeout]);

	const handleInputChange = async (event) => {
		const { value } = event.target;
		setSearchTerm(value);

		// If a request is pending, don't initiate a new one
		if (isRequestPending) {
		return;
		}

		// Clear the previous timeout
		if (typingTimeout) {
		clearTimeout(typingTimeout);
		}

		// Set a new timeout
		setTypingTimeout(
		setTimeout(async () => {
			setIsRequestPending(true);

			try {
				const response = await fetchWithDefaults(`/leadSearch?search=${value}&agent=${agentId}`);
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const jsonData = await response.json();
				if(jsonData.status===false){
					setResults([{borrower_first:'No Results'}]);
					setIsRequestPending(false);
				}
				else{
					setResults(jsonData);
					setIsRequestPending(false);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		}, 500)
		);
	};

	const openBugReport=()=>{
		setBugReport(!bugReport);
	};
	const openMessages=()=>{
		dispatch(setOpenMessages(true));
	}
  	const openLeaderBoard=()=>{
		dispatch(setOpenLeaderBoard(true));
	}
	const openMissedCalls=()=>{
		dispatch(setOpenCalls(true));
	}
	const openVoicemails=()=>{
		dispatch(setOpenVoicemails(true));
	}
	const openSearch=()=>{
		setSearch(!search)
	}
	const handleCloseSearch=()=>{
		setSearch(!search)
	}
	const fetchNewPage=(page)=>{
		fetchPage(page)
	}
	useEffect(() => {
		return () => {
		// Clear the typing timeout when component unmounts
			if (typingTimeout) {
				clearTimeout(typingTimeout);
			}
		};
	}, [typingTimeout]);

	const debouncedBento= useDebouncedCallback(async ()=>{
		try {
			const response = await fetchWithDefaults(`/quility/appMenu?agent=${agentId}`);
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const jsonData = await response.json();
			if(jsonData.status===false){

			}
			else{
				console.log(jsonData)
				setBento(jsonData);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	})

    const gatherBento = async ()=>{
        if(!debouncedBento.isPending()){
            debouncedBento()
        }
    }

	const openBento=()=>{
		setIsBentoOpen(!isBentoOpen)
	}

	const isColor = (strColor) => {
		const s = new Option().style;
		s.color = strColor;
		return s.color !== '';
	}

	const getStyle=(color)=>{
		if(isColor(color)){
			return {backgroundColor: color}
		}
		return {}
	}

	useEffect(()=>{
        gatherBento()
	},[])
	const goTo=(where)=>{
 		window.location.href=where
	}

    useEffect(()=>{
        if(searchInputRef.current){
            searchInputRef.current.focus()
        }
    }, [search===true])

    const {isB2B} = useContext(AgentContext)
    const colorData = useSelector(state => state.colorData)

  	return (
		<div id="barWrapper">
			<div className="bento">
				{(bento && agentInfo.organization==='master' || bento.length > 0) && (
					<span  onClick={()=>openBento()} className="fontello" style={{marginTop: '3px'}}><Icon name={'grid-q'} size={22} className="topBarIcon" adjust="fontello" /></span>
				)}
			</div>
			{isBentoOpen && (
				<div className="bentoBox">
					{bento && bento.map((item, index) => (
						<div className={`${item.color} bentoBlock`} style={getStyle(item.color)} onClick={()=>goTo(item.href)}>
                            {item.icon === 'icon-q-bento-funnel' ? (
                                <div className="fontello" style={{ height: '30px', margin: '20px 15px', marginTop: '3px', transform: 'rotate3d(0, 0, 0, 180deg)'}}>
                                    <div style={{height: 28, width: 28}} className='q-funnel-icon'></div>
                                </div>
                            ) : (
                                <span className="fontello" style={{ height: '30px', margin: '20px 15px', marginTop: '3px' }}><Icon name={`${item.icon ? item.icon.split('icon-')[1] : ''}`} size={22} className="topBarIcon" adjust="fontello" /></span>
                            )}
							<div className="bentoName">{item.title}</div>
						</div>
					))}
				</div>
			)}

            {!isB2B ? (
                <div className="imageWrapper">
                    <img src={dynamicLogo ? dynamicLogo : logo} alt="Main Logo" className="mainLogo"/>
                </div>
            ) : (
                <div className="imageWrapper">
                    <img src={b2blogo} alt="Main Logo" className="mainLogo"/>
                </div>
            )}

			<div className="otherBarOptions">
				<span  onClick={()=>openSearch()} className="fontello" style={{marginTop: '-7px'}}><Icon name={'q-search'} size={22} className="topBarIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span>

				{search &&(
					<div className="searchModal">
						<div className="extraLayer">
							<div className="searchInner">
                                <div style={{zIndex: '2', position: 'absolute', width: 48, height: 48, right: 10, top: 5 }}>
                                    <BrandedIconButton clickHandler={_ => handleCloseSearch()} buttonType={brandedButtonTypes.TERTIARY} >
                                        <XClose />
                                    </BrandedIconButton>
                                </div>
								<div className="searchTitle">Search for leads</div>
								<div className="subTitle">Search by name, number, or email</div>
								<input className="searchModalBar"
									value={searchTerm}
									onChange={handleInputChange}
                                    ref={searchInputRef}
								/>
								<span className="searchModalSearchButton">
									<span className="fontello" style={{marginTop: '-7px'}}><Icon name={'q-search'} size={22} className="closeIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span>
								</span>
								<div className="searchResults">
									{results  && results.map((item, index) => (
										<div className="searchResult" onClick={()=>[setSearchTerm(''),setResults(false),openLead(item.lead_id)]} key={index}>
											<div className="searchHeader">
												<span className="searchName">{item.borrower_first} {item.borrower_last}</span>
											</div>
											<div className="resultLine">
												<div className="lineBlock">
													<div className="resultLineTitle">State</div>
													<span className="searchResultValue">{item.state}</span>
												</div>
												<div className="lineBlock">
													<div className="resultLineTitle">Type</div>
													<span className="searchResultValue">{item.lead_type}</span>
												</div>
											</div>
											<div className="resultLine">
												<div className="lineBlock">
													<div className="resultLineTitle">Status</div>
													<span className="searchResultValue">{item.statusName ? item.statusName : 'No Status'}</span>
												</div>
												<div className="lineBlock">
													<div className="resultLineTitle">Contacted</div>
													<span className="searchResultValue">{item.last_contacted ? item.last_contacted : 'Never Contacted'}</span>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				)}

				{/* <span className="fontello" onClick={()=>openMissedCalls()}><Icon name="q-phone-call-missed" size={22} className="topBarIcon" adjust="fontello" /></span> agentMissedCalls */}

                <span className='topBarIconWrapper'>
                    <span className="fontello" onClick={()=>openMissedCalls()}><Icon name="q-phone-call-missed" size={22} className="topBarIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span>
                    {parseInt(agentMissedCalls) > 0 &&(
						<span className="alertBadge">{agentMissedCalls}</span>
					)}
                </span>

				<span className="topBarIconWrapper">
					<span className="fontello" onClick={()=>openVoicemails()}><Icon name="q-voicemail" size={22} className="topBarIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span>
					{parseInt(unheardVoicemails) > 0 &&(
						<span className="alertBadge">{unheardVoicemails}</span>
					)}

				</span>

				<span className="fontello" onClick={()=>openLeaderBoard()}><Icon name="q-award-medal" size={22} className="topBarIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span>
				<span className="topBarIconWrapper">
					<span className="fontello" onClick={()=>openMessages()}><Icon name="message-circle-q" size={22} className="topBarIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span>
					{parseInt(agentUnreadMessages) > 0 &&(
						<span className="alertBadge">{agentUnreadMessages}</span>
					) }
				</span>

			</div>
			{/*bugReport && (
				<div className="bugReportWrapper">
					<BugReport agentId={agentId} openBugReport={openBugReport}/>
				</div>
			)*/}
			<div className="barMenu">
				<AgentInfo fetchNewPage={fetchNewPage} signOut={signOut}/>
			</div>
		</div>
	);
}

export default HeaderBar;

